import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  selectUser,
  withTextLocalizer,
  LocalizePropType,
  getNextUserOpenChallengeRoute,
  updateUser,
  isCTF,
} from 'getaway-data-layer';
import { useFormik } from 'formik';
import { format } from 'date-fns';
import DoBView from './DoBView';
import {
  maxBirthDate,
  minBirthDate,
  DoBModal,
  DoBSchema,
} from '../../../../validation';
import {
  GA_TITLES,
  isDashboardScreen,
  navigateTo,
  reportGAEvent,
  showAlert,
} from '../../../../utils';
import { useQuery } from '../../../../hooks/useQuery';

interface Values {
  firstName: string;
  lastName: string;
  dateOfBirth: any;
  streetName: string;
  streetNumber: string;
  city: string;
  postalCode: string;
  country: string;
}

type Props = {
  localize: LocalizePropType;
};

const DoBContainer = ({ localize }: Props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user: any = useSelector(selectUser);
  const query = useQuery();
  const next = query.get('next');

  const onSubmit = (values: Values) => {
    const formattedBirth = format(new Date(values.dateOfBirth), 'yyyy-MM-dd');
    dispatch(
      updateUser(
        {
          dateOfBirth: formattedBirth.trim(),
        },
        (updatedUser) => {
          if (isDashboardScreen()) {
            if (next === 'schufa') {
              navigateTo(history, `/dashboard/schufa`);
            } else {
              navigateTo(history, `/dashboard/tariff`);
            }
          } else {
            navigateTo(history, getNextUserOpenChallengeRoute(updatedUser));
          }
          reportGAEvent(GA_TITLES.ON_BOARDING.DOB_SUBMITTED);
        },
        () => {}
      )
    );
  };

  const onClose = () => {
    if (isDashboardScreen()) {
      navigateTo(history, '/settings');
    } else {
      showAlert(
        '',
        localize('cancel.FirstSteps.dialog.message'),
        localize('cancel.FirstSteps.dialog.yes'),
        () => navigateTo(history, '/settings'),
        localize('cancel.FirstSteps.dialog.no'),
        () => {},
        true
      );
    }
  };

  const DoBFormik = useFormik({
    initialValues: DoBModal(user),
    validationSchema: DoBSchema(localize),
    onSubmit,
  });

  return (
    <>
      <DoBView
        localize={localize}
        formik={DoBFormik}
        minDate={minBirthDate}
        maxDate={maxBirthDate}
        onClose={onClose}
      />
    </>
  );
};

export default withTextLocalizer(DoBContainer);
